export const MAX_ATTACHMENT_SIZE_BYTES = 10 * 1024 * 1024;
export const MAX_PENDING_ATTACHMENTS = 5;

export const ACCEPTED_ATTACHMENT_EXTENSIONS = [
  ".pdf",
  ".doc",
  ".docx",
  ".xls",
  ".xlsx",
  ".jpg",
  ".jpeg",
  ".png",
  ".gif",
  ".tif",
  ".txt",
  ".xml",
  ".html",
  ".htm",
] as const;

export const ATTACHMENT_ACCEPT = ACCEPTED_ATTACHMENT_EXTENSIONS.join(",");

const EXTENSION_ALIASES: Record<string, string> = {
  jpeg: "jpg",
  htm: "html",
};

export const canonicalAttachmentExtension = (filename: string): string => {
  const raw = filename.split(".").pop()?.toLowerCase() ?? "";
  return EXTENSION_ALIASES[raw] ?? raw;
};
